
export class TokenKey {
    public accessToken;
    public refreshToken;
    public expiresOn;
}
